import React from 'react';

import HistoryIcon from '../../../../../assets/Svg/HistoryIcon';
import Tooltip from '../../../Tooltip/Tooltip';
import styles from './HistoryTriggerButton.module.scss';

interface HistoryTriggerButtonProps {
    column?: any;
    row?: any;
    // Same signature as DealsRow.handleOwnerHistoryClick(row, field, label, column).
    onHistoryClick?: (row: any, field: string, label?: string, column?: any) => void;
    // Optional explicit label; falls back to the column header, then 'Field'.
    label?: string;
}

/**
 * Hover-revealed history icon for a table cell. Wired generically by DataTable for
 * any column with `isHistoryEnabled` (see DataTable.tsx). Renders nothing unless the
 * column has `isHistoryEnabled` and a history handler is wired, so it is a no-op on
 * cells that don't opt in. Reveal-on-hover is driven by the `data-history-trigger`
 * attribute (see the scss), which lets any wrapper reveal it without coupling
 * to a CSS-module class name.
 */
export const HistoryTriggerButton: React.FC<HistoryTriggerButtonProps> = ({ column, row, onHistoryClick, label }) => {
    if (!column?.isHistoryEnabled || !onHistoryClick) return null;

    const historyLabel =
        label ||
        (typeof column?.headerOriginalLabel === 'string' && column.headerOriginalLabel) ||
        (typeof column?.headerLabel === 'string' && column.headerLabel) ||
        'Field';

    return (
        <Tooltip
            content={`${historyLabel} History`}
            direction="right"
            usePortal={true}
            small={true}
            fitContent={true}
            contentClassName={styles.HistoryTooltipContent}
        >
            <button
                type="button"
                data-history-trigger
                aria-label={`View ${historyLabel} history`}
                onClick={(e) => {
                    e.stopPropagation();
                    onHistoryClick(row, column.field, historyLabel, column);
                }}
                className={styles.HistoryTriggerButton}
            >
                <HistoryIcon width="16" height="16" />
            </button>
        </Tooltip>
    );
};
